<template>

    <div class="view-configurator">

        <div style="display: flex">

            <input type="range" style="transform: rotate(90deg); margin-right: -50px;" v-if="getBoundingBoxMinY !== getBoundingBoxMaxY" :min="getBoundingBoxMinY" :max="getBoundingBoxMaxY" :value="getBoundingBoxCurrentY" @input="setBoundingBoxTopAndRerender">

            <div :id="`canvas-${productConfigurationView.id}-container`">
                <canvas :id="`canvas-${productConfigurationView.id}`"></canvas>
            </div>

            <div :id="`canvas-to-png-${productConfigurationView.id}-container`" style="display: none!important;">
                <canvas :id="`canvas-to-png-${productConfigurationView.id}`"></canvas>
            </div>

        </div>

        <input type="range" v-if="getBoundingBoxMinX !== getBoundingBoxMaxX" :min="getBoundingBoxMinX" :max="getBoundingBoxMaxX" :value="getBoundingBoxCurrentX" @input="setBoundingBoxLeftAndRerender">

        <div id="zoom" v-if="getIsComplexTemplate">
            <div class="btn-group">
                <button class="btn btn-blue" @click="moveSelectedObjectToCenter" :disabled="false"><i class="material-icons" style="font-size: 18px;">center_focus_strong</i> &nbsp;Element zentrieren</button>
            </div>
            <div class="btn-group">
                <button class="btn" @click="setMouseMod(1)" :disabled="mouseMod === 1"><i class="material-icons" style="font-size: 18px;">mouse</i> Auswahl</button>
                <button class="btn" @click="setMouseMod(2)" :disabled="mouseMod === 2"><i class="material-icons">zoom_in</i> Zoom</button>
                <button class="btn btn-blue" @click="setMouseMod(3)" :disabled="mouseMod === 3"><i class="material-icons" style="font-size: 18px;">pan_tool</i> &nbsp;Navigation</button>
            </div>
            <div @click="resetZoom" title="Click to reset">
                {{ currentZoom }}% <i class="material-icons">zoom_in</i>
            </div>
        </div>

    </div>
</template>

<script>
    import Canvas from "./../structures/Canvas";
    import BoundingBox from "./../structures/canvas-objects/BoundingBox";
    import TextObject from "../structures/canvas-objects/TextObject";
    import TextboxObject from "../structures/canvas-objects/TextboxObject";
    import configuration from "../configuration/Configuration";

    export default {
        name: "CanvasView",
        data: () => ({
            canvas: null,
            canvasObjectsOnProductConfigurationView: [],
            mouseMod: null,
            globalClickListener: null
        }),
        computed: {

            getBoundingBoxMaxY() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getMaxY();
            },

            getBoundingBoxMinY() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getMinY();
            },

            getBoundingBoxCurrentY() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getTop();
            },

            getBoundingBoxMaxX() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getMaxX();
            },

            getBoundingBoxMinX() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getMinX();
            },

            getBoundingBoxCurrentX() {
                const canvas = this.productConfigurationView.canvas;

                if (! canvas)
                    return 0;

                const boundingBox = this.productConfigurationView.canvas.getBoundingBox();

                if (! boundingBox)
                    return 0;

                return boundingBox.getLeft();
            },

            currentZoom() {

                if (this.productConfigurationView.canvas)
                    if (this.productConfigurationView.canvas.getCanvas())
                        return parseInt( this.productConfigurationView.canvas.getCanvas().getZoom() * 100 );

            },

            getIsComplexTemplate() {
                return configuration.getConfig().template.simple === false;
            }

        },
        methods: {
            setMouseMod(newMouseMod) {
                window.EventHandler.mouseMod = newMouseMod;
            },
            setBoundingBoxTopAndRerender(event) {
                this.productConfigurationView.canvas.getBoundingBox().setTop(+ event.target.value);
                this.productConfigurationView.canvas.render();
            },
            setBoundingBoxLeftAndRerender(event) {
                this.productConfigurationView.canvas.getBoundingBox().setLeft(+ event.target.value);
                this.productConfigurationView.canvas.render();
            },
            clearSelection() {
                if (this.canvas.getCurrentSelectedObjects().length > 0) {
                    this.canvas.setCurrentSelectedObjects([]);
                    this.canvas.render();
                }
            },
            resetZoom() {

                const zoom = 2;
                const canvas = this.productConfigurationView.canvas;

                if (true) {
                    canvas.getCanvas().absolutePan({x:0, y:0});
                    canvas.getCanvas().setZoom(1);
                } else {
                    canvas.getCanvas().setZoom(1);
                    const
                        vpw = canvas.getCanvas().width / zoom,
                        vph = canvas.getCanvas().height / zoom,
                        x = canvas.getBoundingBox().getLeft() - vpw / 2,
                        y = canvas.getBoundingBox().getTop() - vph / 2;

                    canvas.getCanvas().absolutePan({x: x, y: y});
                    console.log('absolutePan ', {x, y, vpw, vph});
                    //canvas.getCanvas().setZoom(zoom);
                }

            },
            moveSelectedObjectToCenter() {
                const
                    /** @var {Canvas} canvas */
                    canvas = this.productConfigurationView.canvas,
                    currentSelectedObjects = canvas.getCurrentSelectedObjects();

                    if (currentSelectedObjects.length === 1) {

                        /** @var {CanvasObject} objectToCenter */
                        const objectToCenter = canvas.getCanvasObjects().find(canvasObject => {
                            return canvasObject.getId() === currentSelectedObjects[0];
                        });

                        // If it is not allowed to move the object, it cannot be centered.
                        if (objectToCenter.getLeftIsManipulable() === false || objectToCenter.getTopIsManipulable() === false) {
                            return;
                        }

                        const
                            boundingBox = canvas.getBoundingBox(),
                            boundingBoxHeight = boundingBox.getHeight(),
                            boundingBoxWidth = boundingBox.getWidth(),
                            boundingRect = objectToCenter.getMatchingFabricObject().getBoundingRect(),
                            height = boundingRect.height,
                            width = boundingRect.width,
                            angle = objectToCenter.getAngle();

                        objectToCenter.setAngle(0);

                        objectToCenter.setLeft(
                            ((boundingBoxWidth - width) / 2) + (boundingBox.getLeft() + (objectToCenter.getMatchingFabricObject().left - boundingRect.left))
                        );

                        objectToCenter.setTop(
                            ((boundingBoxHeight - height) / 2) + (boundingBox.getTop() + (objectToCenter.getMatchingFabricObject().top - boundingRect.top))
                        );

                        objectToCenter.setAngle(angle);

                        canvas.render();

                    }
            },
            initWhenMounted() {

                this.mouseMod = window.EventHandler.mouseMod;

                window.EventHandler.$on('newMouseModSelected', (newMouseMod) => {
                    if ([1, 2, 3].find(number => newMouseMod === number)) {
                        this.mouseMod = newMouseMod;
                        if (newMouseMod === 1)
                            this.canvas.getCanvas().hoverCursor = 'default';
                        if (newMouseMod === 3)
                            this.canvas.getCanvas().hoverCursor = 'zoom-in';
                        if (newMouseMod === 3)
                            this.canvas.getCanvas().hoverCursor = 'grab';
                    }
                });

                /**
                 * @type Canvas
                 */
                const canvas = this.productConfigurationView.canvas;

                /**
                 * @type BoundingBox
                 */
                const boundingBox = new BoundingBox(
                    canvas,
                    this.productConfigurationView.boundingBox.x.min,
                    this.productConfigurationView.boundingBox.x.max,
                    this.productConfigurationView.boundingBox.y.min,
                    this.productConfigurationView.boundingBox.y.max
                );

                boundingBox.set({
                    width: this.productConfigurationView.boundingBox.sizes.width,
                    height: this.productConfigurationView.boundingBox.sizes.height,
                    left: this.productConfigurationView.boundingBox.x.current,
                    top: this.productConfigurationView.boundingBox.y.current
                });

                canvas.createCanvas(
                    `canvas-${this.productConfigurationView.id}`,
                    this.productConfigurationView.canvasWidth,
                    this.productConfigurationView.canvasHeight,
                    boundingBox,
                    this.canvasObjectsOnProductConfigurationView
                );

                //if (window['w2p_admin'])
                //canvas._boundingBox = null;

                if (! window.canvas )
                    window.canvas = [];

                window.canvas[`canvas-${this.productConfigurationView.id}`] = canvas;
                this.canvas = canvas;

                canvas.initEventHandler();

                this.globalClickListener = ({target}) => {
                    if (target.nodeName !== 'CANVAS') {
                        this.clearSelection();
                    }
                };

                document.addEventListener('click', this.globalClickListener);

                canvas.render();

            }
        },
        props: {
            productConfigurationView: {
                type: Object,
                default: () => ({})
            },
            blueprintConfigurationMode: {
                type: Boolean,
                default: false
            }
        },
        mounted() {

            this.initWhenMounted();

        },
        beforeDestroy() {
            document.removeEventListener('click', this.globalClickListener);
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    .view-configurator {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
    }

    #canvas-background-image {
        display: none;
    }

    #zoom {
        display: flex;
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: $blue-color;
        font-weight: bold;
        font-size: 1.0rem;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;
        height: 30px;

        &.btn-red {
            background-color: #D85846;
        }

        &[disabled=disabled] {
            background-color: darken($grey-font, 20);
            cursor: default;
        }

        &:hover {
            cursor: default;
        }

        &[disabled=disabled]:hover {
            cursor: pointer;
        }
    }

    .btn-group {
        display: flex;
        .btn {
            border-radius: 0px;
        }
        .btn:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        .btn:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }

</style>